import React, { Component } from 'react';
import { connect } from 'react-redux'
import { ThunkDispatch } from 'redux-thunk'
import { AnyAction } from 'redux'
import { RootState } from '../../../../../core/reducers';
import { Button, Row, Col, Divider, Popconfirm } from 'antd';
import { 
    actionGetReportDetailEntryIns,
    actionOperateReportRemark, 
} from '../../../../../core/actions/scanner/report';
import { RouteComponentProps, withRouter, Link } from 'react-router-dom';
import moment from 'moment'
import './index.css'
import user_reportImg from './images/user_report.png'
import expert_dataImg from './images/expert_data.png'
import uitra_sImg from './images/uitra_s.png'
import uitra_xImg from './images/uitra_x.png'
import leapImg from './images/leap.png'
import icon_print from './images/icon_print.png'
import icon_save from './images/icon_save.png'
import icon_designdoc from './images/icon_designdoc.png'
import RemarkForm from './remarkForm'

interface StateProps {
    routeKey: any
    orgInfo: any
    reportDetail: any
}

interface DispatchProps {
    getReportDetail(data): void
    operateReportRemark(data, type, isMerchant): void
}

interface RouteProps  {
    id: string
}
type PropsType = RouteComponentProps<RouteProps> & StateProps
class Index extends Component<PropsType & DispatchProps> {
    
    state = {
        remarkVisible: false,
    }

    componentDidMount () {
        let id = this.props.match.params.id;
        this.props.getReportDetail(id)
    }

    download = (data) => {
        if(!data) return;
        let files = [
            data.footShape.left.model3DUrl,
            data.footShape.right.model3DUrl,
            data.shoesCustomization.leftInsoleModel.url,
            data.shoesCustomization.rightInsoleModel.url,
        ];
        files.forEach(url => {
           let a = document.createElement('a');
           let e = document.createEvent('MouseEvent');
           e.initEvent('click', false, false);
           a.href = url;
           a.download = '';
           a.target = '_blank';
           a.dispatchEvent(e);
           a.click();
        })
    }

    onPrint = (name, time) => {
        if(name) {
            document.title = '报告-' + name + '-' + time;
        }
        else {
            document.title = '报告-' + time;
        }
        
        window.print();
        setTimeout(() => {
            document.title = 'SennoFeet足压后台';
        }, 1000);
    }

    goDetail = (key) => {
        const { history} = this.props;
        let id = this.props.match.params.id;
        history.push(`/institution/reportList/${key}/` + id, 'back');
    }

    goBack = () => {
        const { history } = this.props;
        history.push('/institution/reportList/true');
    }

    onShowRemark = () => {
        this.setState({
            remarkVisible: true
        })
    }

    onSaveRemark = (formdata) => {
        let data = this.props.reportDetail || {};
        let detail = data.detail || {};
        let sdata = {
            ticket: detail.ticket,
            remark: formdata.remark,
        }
        let isMerchant = false;
        const { history } = this.props;
        let pathname = history.location.pathname;
        if(pathname.search('/merchant') !== -1) {
            isMerchant = true;
        }
        if(detail.remark) {
            this.props.operateReportRemark(sdata, 'update', isMerchant);
        }
        else {
            this.props.operateReportRemark(sdata, 'add', isMerchant);
        }

        this.setState({
            remarkVisible: false,
        })
        
    }

    onCancelRemark = () => {
        this.setState({
            remarkVisible: false,
        })
    }

    onDeleteRemark = () => {
        let data = this.props.reportDetail || {};
        let detail = data.detail || {};
        let sdata = {
            ticket: detail.ticket,
        }
        let isMerchant = false;                                                                                                                               
        const { history } = this.props;
        let pathname = history.location.pathname;
        if(pathname.search('/merchant') !== -1) {
            isMerchant = true;
        }
        this.props.operateReportRemark(sdata, 'delete', isMerchant);
    }

    render () {

        let data = this.props.reportDetail || {};
        let examineeResult = data.examineeResult || {};
        // let timeSave = data.creationTimestamp ? moment(+data.creationTimestamp).format('YYYYMMDDHHmmss') : '';
        let detail = data.detail || {};
        let error = '';
        if(detail.state == 'PROCESSING' || detail.state == '') {
            error = '报告正在处理中'
        }
        else if(detail.state == 'COMPLETED' && (!detail.valid || !detail.footPressure.valid)) {
            error = '报告数据错误，请重新测量!'
        }

        const orgInfo = this.props.orgInfo;
        let hide = true;
        // if(orgInfo.id !== "459") { //"喜马拉雅总后台"
        //     hide = false;
        // }

        let popText = (
            <div>数据加载中</div>
        )
            
        let footShape = detail.footShape || {};
        let shoesCustomization = detail.shoesCustomization || {};
        if(!error) {
            popText = (
                <div className="pop-downloadStl">
                    请点击下载文件
                    <ul>
                        <li>
                            左:
                            {  
                                footShape.left && 
                                footShape.left.model3DUrl && 
                                <a href={footShape.left.model3DUrl}>脚型模型</a>
                            }
                            {  
                                shoesCustomization.leftInsoleModel && 
                                shoesCustomization.leftInsoleModel.url && 
                                <a href={shoesCustomization.leftInsoleModel.url}>鞋垫模型</a>
                            }
                        </li>
                        <li>
                            右:
                            {
                                footShape.right &&
                                footShape.right.model3DUrl && 
                                <a href={footShape.right.model3DUrl}>脚型模型</a>
                            }
                            {
                                shoesCustomization.rightInsoleModel &&
                                shoesCustomization.rightInsoleModel.url && 
                                <a href={shoesCustomization.rightInsoleModel.url}>鞋垫模型</a>
                            }
                        </li>
                    </ul>
                </div>
             )
        }

        let id = this.props.match.params.id;
        let routeKey = this.props.routeKey;
        let examinee = detail.examinee || {};

        return (
           <div className="reportDetailScan model">
                <div className="info">
                    <div className="overflow-hidden">
                        <h3 className="left margin-bottom-20">报告详情</h3>
                    </div>
                    <ul>
                        <li>姓名: {examineeResult.name}</li>
                        <li>联系电话: {examinee.mobileNumber}</li>
                        <li className="height">身高: {examineeResult.heightScalar || ''} cm</li>
                        <li className="height">体重: {examineeResult.weightScalar || ''} kg</li>
                    </ul>
                    <ul>
                        <li>扫描ID: {data.examinationReportId}</li>
                        <li>测评商户: {data.orgName}</li>
                        <li>
                            <Popconfirm 
                                placement="right" 
                                title={popText} 
                                okText="关闭"
                                >
                                <Button 
                                    type="primary" 
                                    className="download" 
                                    >下载文件</Button>
                            </Popconfirm>
                        </li>
                    </ul>
                    <p> 
                        <span className='margin-right-12'>备注: {detail.remark}</span>
                        {
                            detail.remark ? 
                            (
                                <span>
                                    <a className='margin-right-12' onClick={() => this.onShowRemark()}>修改</a>
                                    <a onClick={() => this.onDeleteRemark()}>删除</a>
                                </span>
                            ) :
                            <a onClick={() => this.onShowRemark()}>添加</a>
                        }
                    </p>
                </div>
                <Divider />
               {
                   error ? (
                    
                    <div className="error_tip">{error}</div>

                   ) : (
                    <div className="report_card">
                    <ul>
                       <Link 
                            to={{
                                pathname: `/${routeKey}/reportList/userReport/${id}`,
                                state: 'back',
                            }}
                            >
                            <li className="card_userReport">
                                <div>
                                    <h4>用户报告</h4>
                                    <p><img src={icon_print} />打印报告</p>
                                    <p><img src={icon_save} />保存报告</p>
                                </div>
                                <img src={user_reportImg} />
                            </li>
                        </Link>
                        <Link
                            to={{
                                pathname: `/${routeKey}/reportList/expertData/${id}`,
                                state: 'back',
                            }}
                            >
                            <li className="card_expertData">
                                <div>
                                    <h4>专家数据</h4>
                                    <p><img src={icon_print} />打印报告</p>
                                    <p><img src={icon_save} />保存报告</p>
                                    <p><img src={icon_designdoc} />设计文件</p>
                                </div>
                                <div className="card_expertData_right">
                                    <img src={expert_dataImg} />
                                    <div>
                                        <p>左脚</p>
                                        <p><span>面积【mm】 </span><span>6090</span></p>
                                        <p><span>前/双足【%】</span><span>18</span></p>
                                        <p><span>前/全足【%】</span><span>48</span></p>   
                                        <p><span>最大压强【gr/%】</span> <span>68</span></p>
                                        <p><span>平均压强【gr/%】</span>  <span>65</span></p>
                                        <p><span>面积【mm】 </span><span>5472</span></p>    
                                        <p><span>后/双足【%</span><span>19</span></p>
                                        <p><span>后/全足【%】</span><span>52</span></p>
                                        <p> <span>最大压强【gr/%】</span><span>82</span></p>
                                        <p><span>平均压强【gr/%】</span><span>77</span></p>
                                    </div>
                                </div>
                            </li>
                        </Link>
                       
                    </ul>
                    <ul>
                        {
                            !hide && (
                                <li className="card_uitraX">
                                    <h4>Ultra-X</h4>
                                    <p className="subtitle">个性化鞋垫设计系统</p>
                                    <p className="des">Lean-Parametric Orthotics</p>
                                    <p className="des">Design System</p>
                                    <img src={uitra_xImg} />
                                    <p className="tip">即将开放</p>
                                </li>
                            )
                        }
                       <Link 
                            to={{
                                pathname: `/${routeKey}/reportList/leap/${id}`,
                                state: 'back',
                            }} 
                            >
                            <li className="card_leap">
                                <div>
                                    <div>
                                        <h4>Leap</h4>
                                        <p className="subtitle">参数化鞋垫设计系统</p>
                                        <p className="des">Lean-Parametric Orthotics</p>
                                        <p className="des">Design System</p>
                                    </div>
                                    <div className="card_leap_right">
                                        <div>
                                            <p>内足弓</p>
                                            <p>
                                                <span></span>
                                            </p>
                                        </div>
                                        <div>
                                            <p>外足弓</p>
                                            <p>
                                                <span style={{left: '18px'}}></span>
                                            </p>
                                        </div>
                                        <div>
                                            <p>内翻</p>
                                            <p>
                                                <span style={{left: '42px'}}></span>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <img src={leapImg} />
                            </li>
                       </Link>
                    </ul>
                    {
                        !hide && (
                            <ul>
                                <li className="card_uitraS">
                                    <h4>Ultra-S</h4>
                                    <p className="subtitle">个性化鞋大底设计系统</p>
                                    <p className="des">Lean-Parametric Orthotics</p>
                                    <p className="des">Design System</p>
                                    <img src={uitra_sImg} />
                                    <p className="tip">即将开放</p>
                                </li>
                            </ul>
                        )
                    }
                </div>
                   )
               }

               <RemarkForm 
                    data={detail}
                    visible={this.state.remarkVisible}
                    onCreate={this.onSaveRemark}
                    onCancel={this.onCancelRemark}
                    />
           </div>
        )
    }
}

function mapStateToProps(state: RootState): StateProps {
    return {
        reportDetail: state.report.reportDetail,
        orgInfo: state.user.orgInfo,
        routeKey: state.user.routeKey,
    }
}

function mapDispatchToProps(dispatch: ThunkDispatch<RootState, null, AnyAction>): DispatchProps {
    return {
        getReportDetail: (data) => {
            dispatch(actionGetReportDetailEntryIns(data))
        },
        operateReportRemark: (data, type, isMerchant) => {
            dispatch(actionOperateReportRemark(data, type, isMerchant))
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Index))